var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('HeaderComponent'),_vm._v(" "),_c('SwiperComponents'),_vm._v(" "),_c('AboutComponent'),_vm._v(" "),_c('ProjectComponentIndex'),_vm._v(" "),_c('ServiceComponent'),_vm._v(" "),_c('FooterComponent'),_vm._v(" "),_c('BackToTop',{attrs:{"visibility-height":500,"bottom":50,"right":50}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-473265ad","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/index.vue
// module id = null
// module chunks = 